import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../../../_helpers/Api'

//images
import docIcon from '../../../../../../assets/img/icons/document.png'
import closeIcon from '../../../../../../assets/img/icons/close.png'
import loader from '../../../../../../assets/img/loader.svg'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import { trans } from '../../../../../../_providers/Translation'
import { FormControlLabel } from '@mui/material'
import BlueSwitch from '@/components/partials/BlueSwitch'
import BankAccount from './BankAccount'

const BANK_FIELDS = ['bank_name', 'bank_iban', 'bank_swift', 'bank_sort_code', 'bank_account_number']

// Accepts both the `bankSettings` collection and the legacy flat bank_* columns
// The order is kept as it comes from the API - only the main screen highlights the default
const extractBanks = data => {
    let list = []

    if (Array.isArray(data?.bankSettings) && data.bankSettings.length) {
        list = data.bankSettings.map((bank, index) => ({
            ...bank,
            is_default: bank.is_default ? 1 : 0,
            _key: bank.id || index + 1
        }))
    } else if (data && BANK_FIELDS.some(field => data[field])) {
        list = [{
            ...BANK_FIELDS.reduce((acc, field) => ({ ...acc, [field]: data[field] }), {}),
            is_default: 1,
            _key: 1
        }]
    }

    if (list.length && !list.some(bank => bank.is_default)) {
        list[0].is_default = 1
    }

    return list
}

function Payments(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        data: null,
        loading: false,
        onSave: null
    })

    const [validations, setValidations] = useState(null)
    const [banks, setBanks] = useState([])

    useImperativeHandle(ref, () => ({
        show: data => {
            setPopup(prev => ({
                ...prev,
                loading: false,
                data: data
            }))
            setBanks(extractBanks(data))
            handleShow()
        },
        hide: () => {
            handleHide()
        },
        onSave: fn => {
            setPopup(prev => ({
                ...prev,
                onSave: fn
            }))
        }
    }))


    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url = 'partners/settings/edit'

        let data = new FormData(e.target)

        Api.post(url, data)
            .then(res => {

                handleHide(e)

                if (typeof popup.onSave === 'function') {
                    popup.onSave()
                }

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    function handleSwitchChange(e) {
        const { name, checked } = e.target

        setPopup((prev) => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: checked ? 1 : 0,
            },
        }))
    }

    const updateBankField = (index, field, value) => {
        setBanks(prev => {
            const next = prev.slice()
            next[index] = { ...(next[index] || {}), [field]: value }
            return next
        })
    }

    const handleSetDefaultBank = index => {
        setBanks(prev => prev.map((bank, i) => ({
            ...bank,
            is_default: i === index ? 1 : 0
        })))
    }

    const handleAddBank = () => {
        setBanks(prev => [...prev, {
            _key: Date.now(),
            is_default: prev.length ? 0 : 1
        }])
    }

    const handleRemoveBank = index => {
        setBanks(prev => {
            const next = prev.slice()
            const [removed] = next.splice(index, 1)

            if (removed?.is_default && next.length) {
                next[0] = { ...next[0], is_default: 1 }
            }

            return next
        })
    }

    const banksDisabled = popup.data?.is_bank_active ? false : true

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary popup-payment-settings medium`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.paymentsSettings')}
                        </h2>
                        <p>
                            {trans('subheadings.paymentsSettings')}
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3>
                                        {trans('labels.bankData')}
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_bank_active"
                                                checked={popup.data?.is_bank_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_bank_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    {banks.map((bank, index) => (
                                        <BankAccount
                                            key={bank.id || bank._key || index}
                                            bank={bank}
                                            index={index}
                                            disabled={banksDisabled}
                                            onUpdateField={updateBankField}
                                            onSetDefault={handleSetDefaultBank}
                                            onRemove={handleRemoveBank}
                                            validations={validations}
                                        />
                                    ))}

                                    <div className="row">
                                        <button
                                            className="button-add button-small"
                                            type="button"
                                            onClick={handleAddBank}
                                            disabled={banksDisabled}
                                        >
                                            {trans('buttons.addBankAccount')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3>
                                        ePay
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_epay_active"
                                                checked={popup.data?.is_epay_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_epay_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        ePay Client ID
                                    </label>

                                    <input
                                        type="text"
                                        name="epay_client_id"
                                        value={popup.data ? popup.data.epay_client_id : ''}
                                        className={validations && validations.epay_client_id ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_epay_active ? false : true}
                                    />

                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <label>
                                        ePay Client Secret
                                    </label>

                                    <input
                                        type="text"
                                        name="epay_client_secret"
                                        value={popup.data ? popup.data.epay_client_secret : ''}
                                        className={validations && validations.epay_client_secret ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_epay_active ? false : true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3>
                                        PayPal
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_paypal_active"
                                                checked={popup.data?.is_paypal_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_paypal_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        PayPal Client ID
                                    </label>

                                    <input
                                        type="text"
                                        name="paypal_client_id"
                                        value={popup.data ? popup.data.paypal_client_id : ''}
                                        className={validations && validations.paypal_client_id ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_paypal_active ? false : true}
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        PayPal Client Secret
                                    </label>

                                    <input
                                        type="text"
                                        name="paypal_client_secret"
                                        value={popup.data ? popup.data.paypal_client_secret : ''}
                                        className={validations && validations.paypal_client_secret ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_paypal_active ? false : true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3>
                                        Stripe
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_stripe_active"
                                                checked={popup.data?.is_stripe_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_stripe_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        Stripe Key
                                    </label>

                                    <input
                                        type="text"
                                        name="stripe_key"
                                        value={popup.data ? popup.data.stripe_key : ''}
                                        className={validations && validations.stripe_key ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_stripe_active ? false : true}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <label>
                                        Stripe Secret
                                    </label>

                                    <input
                                        type="text"
                                        name="stripe_secret"
                                        value={popup.data ? popup.data.stripe_secret : ''}
                                        className={validations && validations.stripe_secret ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_stripe_active ? false : true}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <label>
                                        Stripe Webhook Secret
                                    </label>

                                    <input
                                        type="text"
                                        name="stripe_webhook_secret"
                                        value={popup.data ? popup.data.stripe_webhook_secret : ''}
                                        className={validations && validations.stripe_webhook_secret ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_stripe_active ? false : true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3 style={{ marginBottom: 0 }}>
                                        {trans('labels.card')}
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_card_active"
                                                checked={popup.data?.is_card_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_card_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3 style={{ marginBottom: 0 }}>
                                        {trans('labels.inCash')}
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_in_cash_active"
                                                checked={popup.data?.is_in_cash_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_in_cash_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3 style={{ marginBottom: 0 }}>
                                        {trans('labels.paypalCreditDebitCard')}
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_paypal_credit_debit_card_active"
                                                checked={popup.data?.is_paypal_credit_debit_card_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_paypal_credit_debit_card_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3 style={{ marginBottom: 0 }}>
                                        {trans('labels.noPaymentNeeded')}
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_no_payment_needed_active"
                                                checked={popup.data?.is_no_payment_needed_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_no_payment_needed_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(Payments)